import { render } from "./UserDetalle.vue?vue&type=template&id=1fc3c16b&scoped=true"
import script from "./UserDetalle.vue?vue&type=script&lang=js"
export * from "./UserDetalle.vue?vue&type=script&lang=js"

import "./UserDetalle.vue?vue&type=style&index=0&id=1fc3c16b&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc3c16b"]])

export default __exports__